<template>
  <div class="c-navigation">

    <div v-bind:class="{ 'is-hidden-on-desktop': hideAuxNavOnDesktop }" class="c-navigation__aux-nav t-navigation-aux">

      <div class="c-navigation__aux-nav__inner">
        <button v-if="backButton" class="c-navigation__aux-nav__button t-navigation-aux__button" @click="historyBack()">
          <span class="c-navigation__aux-nav__button__icon fa fa-2x fa-chevron-left"></span>
        </button>
        <span class="c-navigation__aux-nav__name">{{ spaceName }}</span>
      </div>

    </div>



    <div class="c-navigation__main-nav t-navigation qa-main-nav"
         v-if="isLoggedIn" @click="togglePointsLedger(false)">
      <div class="c-navigation__main-nav__inner">
        <template v-for="(item, index) in websiteConfig.left_nav_menu">
            <a
              v-if="item.linkType=='external'"
              :key="index"
              class="c-navigation__main-nav__link t-navigation__item qa-nav-link"
              :href="item.url"
              :target="item.target">
              <i :class="'c-navigation__main-nav__link__icon ' + item.icon + ' fa-2x'"></i>
              <span class="c-navigation__main-nav__link__text">{{item.text}}</span>
            </a>

            <router-link
              v-else-if="isVisible(item)"
              :key="index"
              class="c-navigation__main-nav__link t-navigation__item qa-nav-link"
              active-class = "t-navigation__item--active"
              :target="item.target"
              :to="getRouteTo(item)">
              <i :class="'c-navigation__main-nav__link__icon ' + item.icon + ' fa-2x'"></i>
              <span class="c-navigation__main-nav__link__text">{{item.text}}</span>
            </router-link>

        </template>
      </div>
    </div>

    <router-link
      v-if  = "isLoggedIn"
      :to   = "{name: 'Dashboard'}"
      class = "c-navigation__logo"
    >
      <img :src="platformImages.navigation_logo_110" :alt="$t('web.app_navigation.alt_text_logo')"
           :srcset="platformImages.navigation_logo_110 + ' 110w, ' + platformImages.navigation_logo_160 + ' 160w, ' +
                  platformImages.navigation_logo_220 + ' 220w, ' + platformImages.navigation_logo_320 + ' 320w'">
    </router-link>


    <div class="c-navigation__points-indicator" v-if="isLoggedIn">
      <a class="c-navigation__points-indicator__link t-points-indicator js-points-ledger-trigger"
         v-if="isLoggedIn" @click="togglePointsLedger(true)">
        <i class="fa fa-star t-points-indicator__icon"></i>
        <span class="t-points-indicator__text">{{ typeof participant !== 'undefined' ? formatNumber(participant.points_balance) : '' }}</span>
      </a>
    </div>



    <points-ledger v-if="isLoggedIn"></points-ledger>



    <div class="c-navigation__public t-navigation"  v-if="!isLoggedIn">
      <div class="c-navigation__public__inner">

        <h1>
          <router-link class="c-navigation__public__platform-name t-navigation-aux__text"
                       :to="{name: 'Dashboard'}">{{ websiteConfig.name }}</router-link>
        </h1>

        <router-link 
            v-if="websiteConfig.enrollment_enabled"
            class="c-navigation__public__link t-navigation-aux__text"
            :to="{name: 'Signup'}">
          {{ $t('web.app_navigation.signup_link') }}
        </router-link>

      </div>
    </div>



  </div>
</template>





<script>
import util from '@/functions'
import PointsLedger from '@/views/components/PointsLedger'
import { mapGetters, mapActions } from 'vuex'
import $ from 'jquery'

export default {
  name: 'AppNavigation',
  props: ['currentSpace', 'hideAuxNavOnDesktop', 'backButton'],
  data () {
    return {
      isLoggedIn: util.isLoggedIn()
    }
  },

  components: {
    'points-ledger': PointsLedger
  },

  computed: {
    ...mapGetters([
      'participant',
      'websiteConfig',
      'platformImages'
    ]),

    spaceName () {
      return this.currentSpace ? this.currentSpace : this.$route.name
    }
  },

  methods: {
    ...mapActions([
      'LOAD_POINTS_LEDGER'
    ]),
    formatNumber (value) {
      return util.formatNumber(value)
    },
    togglePointsLedger (open) {
      if (open && !$('body').hasClass('has-modal')) {
        this.LOAD_POINTS_LEDGER()
        util.togglePointsLedger(open)
      } else if (open && $('body').hasClass('has-modal')) {
        util.togglePointsLedger(false)
      } else {
        util.togglePointsLedger(open)
      }
    },
    /**
     * Format custom named routes if needed
     */
    getRouteTo (navItem) {
      if (navItem.linkType === 'internal') {
        return {name: 'Page_' + navItem.id}
      }

      if (navItem.linkType === 'program_dashboard') {
        return {name: 'ProgramDashboard', params: {id: navItem.id}}
      }

      return {name: navItem.platform_default}
    },
    /**
     * Hide Rewards if catalog is not enabled
     */
    isVisible (navItem) {
      if (navItem.linkType === 'platform' && navItem.platform_default === 'Rewards') {
        return typeof this.participant !== 'undefined'
          ? this.participant.catalog_is_enabled
          : false
      }

      return true
    },
    historyBack () {
      this.$router.go(-1)
    }
  },

  mounted () {
    let activeEl = document.getElementsByClassName('t-navigation__item--active')[0]

    if (activeEl) {
      activeEl.scrollIntoView({block: 'center'})
    }
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// AppNavigation.vue?52e8ef55